import React, { useState } from "react";
import IconButton from "@mui/material/IconButton";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import "../../../css/DesignSystem/Arrows/Arrows.css";

const ArrowRight = ({ onClick, disabled }) => {
  const [clicked, setClicked] = useState(false);

  return (
    <div
      className={`Arrow-Container ${clicked ? "clicked" : ""}  ${
        disabled ? "disabled" : ""
      }`}
      onClick={() => {
        setClicked(!clicked);
        !disabled && onClick();
      }}
    >
      <IconButton className="Arrow-Icon" disableRipple>
        <ChevronRightIcon className="Arrow-Icon" />
      </IconButton>
    </div>
  );
};

export default ArrowRight;
